import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { EActionType } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

interface ICallButton {
  actionType: EActionType;
  onClick(): void;
  phones: string[];
}

export const CallButton = ({ onClick, phones, actionType }: ICallButton) => {
  return (
    <Button data-actionType={actionType} onClick={onClick}>
      {formatPhoneNumber(phones[0]).slice(0, -3)}...
    </Button>
  );
};
